import TextField from "../components/common/TextField";
import { useFormik } from "formik";
import Button from "../components/common/Button";
import { showToast, ToastType } from "../utils/toast.utils";
import { useCreateRestaurantRequestMutation } from "../store";
import { restaurantRequestSchema } from "../utils/validations";
import {
  ApplicantRole,
  ApplicantRoleLabels,
  RestaurantRequest,
  WeeklyOrders,
  WeeklyOrdersLabels,
} from "../types";
import Dropdown from "../components/common/DropDown";

const RestaurantRequestForm = () => {
  const [createRestaurantRequest, { isLoading }] =
    useCreateRestaurantRequestMutation();

  const handleSubmitForm = async (values: Omit<RestaurantRequest, "_id">) => {
    const result = await createRestaurantRequest(values);
    if (!result.error) {
      showToast("Demande envoyée avec succès", ToastType.SUCCESS);
    }
  };

  const {
    values,
    errors,
    touched,
    isSubmitting,
    setFieldValue,
    setFieldTouched,
    handleChange,
    handleBlur,
    handleSubmit,
  } = useFormik<Omit<RestaurantRequest, "_id">>({
    initialValues: {
      displayName: "",
      address: "",
      city: "",
      weeklyOrders: "" as WeeklyOrders,
      role: "" as ApplicantRole,
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
    },
    validationSchema: restaurantRequestSchema,
    onSubmit: handleSubmitForm,
  });

  return (
    <form
      className="w-full grid grid-cols-2 gap-4"
      onSubmit={handleSubmit}
      id="restaurant-request-form"
    >
      {/* --- 2 per line text fields --- */}
      <TextField
        id="displayName"
        value={values.displayName}
        onChange={handleChange}
        onBlur={handleBlur}
        touched={touched}
        errors={errors}
        placeholder="Nom restaurant"
      />
      <TextField
        id="address"
        value={values.address}
        onChange={handleChange}
        onBlur={handleBlur}
        touched={touched}
        errors={errors}
        placeholder="Adresse"
      />
      <div className="col-span-2">
        <Dropdown
          id="weeklyOrders"
          placeholder="Commandes prévues par semaine"
          options={Object.values(WeeklyOrders).map((key) => ({
            value: key,
            label: WeeklyOrdersLabels[key],
          }))}
          value={values.weeklyOrders}
          setFieldValue={setFieldValue}
          setFieldTouched={setFieldTouched}
          errors={errors}
          touched={touched}
          isFetching={isLoading}
        />
      </div>

      <div className="col-span-2">
        <Dropdown
          id="role"
          placeholder="Votre fonction"
          options={Object.values(ApplicantRole).map((key) => ({
            value: key,
            label: ApplicantRoleLabels[key],
          }))}
          value={values.role}
          setFieldValue={setFieldValue}
          setFieldTouched={setFieldTouched}
          errors={errors}
          touched={touched}
          isFetching={isLoading}
        />
      </div>
      <div className="col-span-2">
        <TextField
          id="city"
          value={values.city}
          onChange={handleChange}
          onBlur={handleBlur}
          touched={touched}
          errors={errors}
          placeholder="Ville"
        />
      </div>
      <TextField
        id="lastName"
        value={values.lastName}
        onChange={handleChange}
        onBlur={handleBlur}
        touched={touched}
        errors={errors}
        placeholder="Nom"
      />
      <TextField
        id="firstName"
        value={values.firstName}
        onChange={handleChange}
        onBlur={handleBlur}
        touched={touched}
        errors={errors}
        placeholder="Prénom"
      />
      <TextField
        id="email"
        value={values.email}
        onChange={handleChange}
        onBlur={handleBlur}
        touched={touched}
        errors={errors}
        placeholder="Email"
      />
      <TextField
        id="phone"
        value={values.phone}
        onChange={handleChange}
        onBlur={handleBlur}
        touched={touched}
        errors={errors}
        placeholder="Téléphone"
      />

      <div className="col-span-2 flex justify-center mt-4">
        <Button
          className="w-1/2 justify-center font-bold py-2 bg-primary rounded text-white"
          disabled={isSubmitting || isLoading}
          type="submit"
        >
          Envoyer
        </Button>
      </div>
    </form>
  );
};

export default RestaurantRequestForm;
